import React from 'react';

import colours from 'styles/colours';
import {headerFontSizes, default as theme} from 'styles/theme';

const defaultLevel = 2;

export default function Title({children, colour, level = defaultLevel, id}) {

    if (isNaN( Number(level))) {
        level = defaultLevel;
    }
    level = Math.min(Math.max(1, level), 6); // <H> tags must be between 1 and 6

    const styles = {
        margin: 0,
        fontSize: headerFontSizes[level] || theme.font.main.size,
        color: colour || colours.font.title.default,
        fontWeight: 400,
        display: 'inline-block',
    };

    return React.createElement(`h${level}`, {style: styles, id}, children);

}